import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

import { STEP$OF$ } from "../../../constants/messages";

const Counter = ({ className, stepNumber, totalSteps }) => (
  <div className={classNames("mydpd-step-counter", className)}>
    <span>{STEP$OF$(stepNumber, totalSteps)}</span>
  </div>
);

Counter.propTypes = {
  className: PropTypes.string,
  stepNumber: PropTypes.number,
  totalSteps: PropTypes.number,
};

export default Counter;
